import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { style } from 'typestyle';
import { useNavigate } from 'react-router-dom';
import * as styles from './offices.styles';
import OfficeInfoOverview from './office-info-overview.component';
import { NavigateToOverview } from './office.component';
import OFFICE_INFORMATION_KEY from './consts/consts';
import BackButton from '../../core/components/back-button/back-button.component';
import PrimaryButton from '../../core/components/buttons/primary-button.component';
import Column from '../../core/components/column/column.component';
import { CrossAxisAlignment, MainAxisAlignment } from '../../core/components/flex/flex.component';
import Row from '../../core/components/row/row.component';
import { IsMobileContext } from '../../core/context/is-mobile';

const OfficeCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();

  const navigateToOverview = NavigateToOverview(navigate, [OFFICE_INFORMATION_KEY]);

  return (
    <div className={style(styles.bottomMargin)}>
      {isMobile ? (
        <Column crossAxisAlignment={CrossAxisAlignment.Stretch} className={style(styles.cornerButton(isMobile))} itemSpacing={12}>
          <BackButton title={t('my-offices')} navigate={navigateToOverview} />
          <Row itemSpacing={12}>
            <PrimaryButton onClick={navigateToOverview}>{t('cancel')}</PrimaryButton>
          </Row>
        </Column>
      ) : (
        <Row className={style(styles.cornerButton(isMobile))} mainAxisAlignment={MainAxisAlignment.SpaceBetween}>
          <BackButton title={t('my-offices')} navigate={navigateToOverview} />
          <Row itemSpacing={12}>
            <PrimaryButton onClick={navigateToOverview}>{t('cancel')}</PrimaryButton>
          </Row>
        </Row>
      )}
      <OfficeInfoOverview />
    </div>
  );
};

export default OfficeCreate;
